// extracted by mini-css-extract-plugin
export default {"main":"LabelDropdown_main__Tjl0r","unavailable":"LabelDropdown_unavailable__DaqAw","label":"LabelDropdown_label__x8-lB"};